import Response from "../../Data/Domain/Response";
import EmissionFactors from "../Domain/EmissionFactors";
import { getEmissionFactors } from "./EmissionFactors.service";

export async function getEmissionFactorsRepository(params) {
  const data = await getEmissionFactors(params);
  return new Response(data, EmissionFactors).getMultiple();
}
